import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  localidades: [],
  provinciaId: null,
  isLoading: false,
};

const localidadSelectorSlice = createSlice({
  name: "business/localidades",
  initialState,
  reducers: {
    fetchLocalidadesInited: {
      prepare: (props) => ({ payload: { props } }),
      reducer: (state) => {
        state.localidades = [];
        state.provinciaId = null;
        state.isLoading = true;
      },
    },
    fetchLocalidadesCompleted: {
      prepare: (value) => ({ payload: { value } }),
      reducer: (state, action) => {
        state.localidades = action.payload.value.localidades;
        state.provinciaId = action.payload.value.provinciaId;
        state.isLoading = false;
      },
    },
    fetchLocalidadesFailed: {
      prepare: (error) => ({ payload: { error } }),
      reducer: (state) => {
        state.localidades = [];
        state.provinciaId = null;
        state.isLoading = false;
      },
    },
    clearLocalidades: {
      prepare: () => ({ payload: {} }),
      reducer: () => ({ ...initialState, localidades: [] }),
    },
  },
});

const {
  fetchLocalidadesInited,
  fetchLocalidadesCompleted,
  fetchLocalidadesFailed,
  clearLocalidades,
} = localidadSelectorSlice.actions;

const fetchLocalidades = (provinciaId) => {
  return async (dispatch, getState, services) => {
    try {
      dispatch(fetchLocalidadesInited({ provinciaId }));
      const response = await services.api.getProvinciasLocalidades(provinciaId);

      const localidades = response
        .filter((v, i) => response.indexOf(v) === i)
        .filter((i) => i !== "")
        .map((item) => ({
          value: item,
          label: item,
        }));
      dispatch(fetchLocalidadesCompleted({ localidades, provinciaId }));
    } catch (error) {
      console.error(error);
      dispatch(fetchLocalidadesFailed(error));
    }
  };
};

export default localidadSelectorSlice.reducer;
export {
  fetchLocalidadesInited,
  fetchLocalidadesCompleted,
  fetchLocalidadesFailed,
  fetchLocalidades,
  clearLocalidades,
};
